import React from "react";

import GroupedLabelledCheckbox from "../GroupedLabelledCheckbox";
import CheckboxGroup from "./";

export const CheckboxGroupExample: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const [value, setValue] = React.useState("long-answer");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setValue(event.target.value);

  return (
    <CheckboxGroup>
      <GroupedLabelledCheckbox
        name="answer"
        label="I enjoy answering questions with a really long speach that nobody can follow what I am talking about 🤓"
        value="long-answer"
        checked={value === "long-answer"}
        onChange={handleChange}
      />
      <GroupedLabelledCheckbox
        name="answer"
        label="I just answer questions 🤷‍♂️"
        value="short-answer"
        checked={value === "short-answer"}
        onChange={handleChange}
      />
    </CheckboxGroup>
  );
};

export const CheckboxGroupErrorExample: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const [value, setValue] = React.useState("long-answer");

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    setValue(event.target.value);

  return (
    <CheckboxGroup>
      <GroupedLabelledCheckbox
        name="error-answer"
        label="I enjoy answering questions with a really long speach that nobody can follow what I am talking about 🤓"
        value="long-answer"
        checked={value === "long-answer"}
        onChange={handleChange}
        invalid
      />
      <GroupedLabelledCheckbox
        name="error-answer"
        label="I just answer questions 🤷‍♂️"
        value="short-answer"
        checked={value === "short-answer"}
        onChange={handleChange}
        invalid
      />
    </CheckboxGroup>
  );
};
